import {
    createDefaultWalletNotFoundHandler,
    registerMwa,
    createDefaultAuthorizationCache,
    createDefaultChainSelector
} from "@solana-mobile/wallet-standard-mobile";

export function initSolanaMobileWallet() {
    registerMwa({
        appIdentity: {
            name: "Loopscale",
            uri: "https://app.loopscale.com"
        },
        authorizationCache: createDefaultAuthorizationCache(),
        chains: ["solana:mainnet"],
        chainSelector: createDefaultChainSelector(),
        onWalletNotFound: createDefaultWalletNotFoundHandler()
    });
}
